export enum PLICategoryEnum {
  'Pharmacy Clinic' = 1,
  'Medical Practitioner A',
  'Medical Practitioner B',
  'Medical Practitioner C',
  'uConsult Medical Practitioner D',
  'Dental',
  'Optometry',
  'Pathology',
  'Radiology',
  'Policy',
  'N/A',
}
export namespace PLICategoryEnum {
  export function values() {
    return Object.keys(PLICategoryEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
